import { render, staticRenderFns } from "./AllScheme.vue?vue&type=template&id=72ca2376&scoped=true&"
import script from "./AllScheme.vue?vue&type=script&lang=js&"
export * from "./AllScheme.vue?vue&type=script&lang=js&"
import style0 from "./AllScheme.vue?vue&type=style&index=0&id=72ca2376&prod&lang=scss&scoped=true&"
import style1 from "./AllScheme.vue?vue&type=style&index=1&id=72ca2376&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ca2376",
  null
  
)

export default component.exports